import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';
import { UserCapabilityName } from '../../types/userCapabilityName';
import { orgsAnalytics } from './types/organizationsAnalytics';

const Organizations = lazy(
  () => import(/* webpackChunkName: "organization" */ './Organizations')
);

const OrganizationCreate = lazy(
  () =>
    import(/* webpackChunkName: "organization-create" */ './OrganizationCreate')
);

const OrganizationViewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-view-page" */ './OrganizationPage'
    )
);

const OrganizationEditDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-details" */ './OrganizationEditOrgDetails'
    )
);

const OrganizationEditServices = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-services" */ './OrganizationEditOrgServices'
    )
);

const OrganizationEditEnterpriseSupport = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-enterprise-support" */ './OrganizationEditOrgEnterpriseSupport'
    )
);

const OrganizationEditFeatureMngmt = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-feature-mngmt" */ './OrganizationEditOrgFeatures'
    )
);

const OrganizationEditAccountTeam = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-account-team" */ './OrganizationEditOrgAccountTeam'
    )
);

const OrganizationEditSystemIdentifiers = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-system-identifiers" */ './OrganizationEditOrgSystemIdentifiers'
    )
);

const OrganizationEditOrgChannelUpload = lazy(
  () =>
    import(
      /* webpackChunkName: "organization-edit-org-channel-upload-settings" */ './OrganizationEditOrgChannelUpload'
    )
);

const {
  organizations,
  orgCreate,
  orgViewPage,
  orgEditDetails,
  orgEditServices,
  orgEditEntSupport,
  orgEditFeatures,
  orgEditAccTeam,
  orgEditSysIdentifiers,
  orgEditChannelUploadSettings,
} = orgsAnalytics;

export const organizationRoutes = (
  <Route path="organizations/*">
    <Route
      path=""
      element={
        <PageRoute
          pageInfo={organizations}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.ViewOrganizations,
            UserCapabilityName.OrganizationsAllView,
          ]}
        >
          <Organizations />
        </PageRoute>
      }
    />
    <Route
      path=":organizationId"
      element={
        <PageRoute
          pageInfo={organizations}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.ViewOrganizations,
            UserCapabilityName.OrganizationsAllView,
          ]}
        >
          <Organizations />
        </PageRoute>
      }
    />
    <Route
      path="create"
      element={
        <PageRoute
          pageInfo={orgCreate}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.CreateOrganization,
          ]}
        >
          <OrganizationCreate />
        </PageRoute>
      }
    />
    <Route
      path="view/:organizationId"
      element={
        <PageRoute
          pageInfo={orgViewPage}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.ViewOrganizations,
            UserCapabilityName.OrganizationsAllView,
          ]}
        >
          <OrganizationViewPage />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/details"
      element={
        <PageRoute
          pageInfo={orgEditDetails}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditDetails />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/services"
      element={
        <PageRoute
          pageInfo={orgEditServices}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditServices />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/entsupport"
      element={
        <PageRoute
          pageInfo={orgEditEntSupport}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditEnterpriseSupport />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/features"
      element={
        <PageRoute
          pageInfo={orgEditFeatures}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditFeatureMngmt />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/accteam"
      element={
        <PageRoute
          pageInfo={orgEditAccTeam}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditAccountTeam />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/sysid"
      element={
        <PageRoute
          pageInfo={orgEditSysIdentifiers}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditOrganization,
          ]}
        >
          <OrganizationEditSystemIdentifiers />
        </PageRoute>
      }
    />
    <Route
      path="edit/:organizationId/channelupload"
      element={
        <PageRoute
          pageInfo={orgEditChannelUploadSettings}
          userCapabilities={[
            UserCapabilityName.CreateChannels,
            UserCapabilityName.EditChannels,
            UserCapabilityName.DeleteChannels,
          ]}
        >
          <OrganizationEditOrgChannelUpload />
        </PageRoute>
      }
    />
  </Route>
);
